import { render, staticRenderFns } from "./styleTwo.vue?vue&type=template&id=1a61fce0&scoped=true&"
import script from "./styleTwo.vue?vue&type=script&lang=js&"
export * from "./styleTwo.vue?vue&type=script&lang=js&"
import style0 from "./styleTwo.vue?vue&type=style&index=0&id=1a61fce0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a61fce0",
  null
  
)

export default component.exports